import { Box, Editable, EditablePreview, EditableTextarea, Heading } from '@chakra-ui/react';
import React from 'react';
import EditButton from '../components/EditButton';
import ContactAddress from './subSections/ContactAddress';
import ContactEmail from './subSections/ContactEmail';
import ContactPhone from './subSections/ContactPhone';
import ContactURL from './subSections/ContactURL';
import { freeFormEdit } from '../utils';
import { saveNotes } from '../components/Notes/utils';
import Index from '../components/Notes';

const PreviewContact = ({ props,  savedResume,  isDesktop }) => {
  const sectionName = 'contact';
  const section = savedResume['contact']['0'];
  const stateProps = props.stateProps;
  return (
      <Box  className="mainBox contact" >
        <Box className='header' >
        <Heading className='names' >{section.first}</Heading>
        <Heading  className='names' >{section.last}</Heading>
        </Box>
        <Box>
          <Box className='infoWrapper'>
            <ContactEmail email = {section.email} />
            <ContactURL url = {section.url} />
            <ContactAddress city = {section.city} state = {section.state} postal_code = {section.postal_code}/>
            <ContactPhone phone = {section.phone} />
            <Box className='contactEditButtonWrap'>
              <EditButton  background='red' props={props} buttonLabel='Edit' target={sectionName}/>
            </Box>
          </Box>
        </Box>
      </Box>
    );
};
export default PreviewContact;
